import React, { useEffect } from 'react';
import { Box, Heading, Image, Button } from '@chakra-ui/react';
import Logo from 'images/logo.svg';
import Faq from './faq';
import Features from './features';
import Footer from './footer';
import ClientShare from './clientShare';
import Showcase from 'images/showcase.png';
import Showcase2x from 'images/showcase@2x.png';
import HeroLogo from 'images/hero-logo.svg';

const Homepage = () => {
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams) {
      const params = Object.fromEntries(urlSearchParams.entries());
      const paramKey = Object.keys(params);
      const val = Object.values(params);
      paramKey[0] === 'ref_code' && sessionStorage.setItem('ref_code', val[0]);
    }
  }, []);

  return (
    <Box background='dark.100'>
      <Box
        maxWidth='780px'
        margin='0 auto'
        textAlign='center'
        pb='160px'
        className='animated fadeInUp'
      >
        <Box
          className='hero-section'
          px={['32px', '32px', '32px', '0px']}
          height='98vh'
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
        >
          <Box justifyContent='center' display='flex' alignItems='center'>
            <Image
              src={Logo}
              alt='logo'
              size={['50px', '50px', '100px', '100px']}
            />
          </Box>
          <Box
            justifyContent='center'
            display='flex'
            alignItems='center'
            my='40px'
          >
            <Image src={HeroLogo} alt='logo' />
          </Box>
          <Heading
            as='h1'
            fontSize={['16px', '16px', '28px', '28px']}
            color='#fff'
            fontFamily='regular'
            fontWeight='regular'
          >
            Affordably premium way to share photos with your clients
          </Heading>
          <a href='/login'>
            <Button
              bg='#fff'
              borderRadius='24px'
              width='200px'
              height='48px'
              fontSize='14px'
              fontWeight='bold'
              fontFamily='bold'
              wordSpacing='2px'
              mt='40px'
              mb='16px'
            >
              Login or Register
            </Button>
          </a>
          <Box fontSize='14px' color='#fff'>
            Get more clients from today!
          </Box>
        </Box>
        <Box className='product-showcase' px={['32px', '32px', '32px', '0px']}>
          <Image
            width='100%'
            pb='120px'
            src={Showcase}
            srcSet={`${Showcase2x} 2x`}
            alt='client album'
          />
          <Box color='white' fontSize={['20px', '20px', '40px', '40px']}>
            Albumshot is all you need, a brand new interface for premium client
            experiences with an authentic look to accelerate brand and business
          </Box>
        </Box>
        <Box
          background='linear-gradient(116.52deg, #6DF0FC 0%, #FF4B93 66.71%)'
          height='1px'
          my='120px'
          mx={['32px', '32px', '32px', '0px']}
        ></Box>
        <Features />
        <ClientShare />
      </Box>
      <Faq />
      <Footer />
    </Box>
  );
};

export default Homepage;
